import React from 'react';
import { Code2, Smartphone, Globe, Users } from 'lucide-react';
import { profileData } from '../data/mockData';

const About = () => {
  const highlights = [
    {
      icon: Smartphone,
      title: 'Mobile Development',
      description: 'Expert in React Native, building cross-platform apps for iOS & Android'
    },
    {
      icon: Globe,
      title: 'Web Development',
      description: 'Proficient in React Js, Next Js for modern web applications'
    },
    {
      icon: Code2,
      title: 'Full Stack',
      description: 'Backend experience with Node Js, Go Lang, and cloud services'
    },
    {
      icon: Users,
      title: 'Tech Leadership',
      description: 'Leading teams, code reviews, and mentoring junior developers'
    }
  ];

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-emerald-600 font-medium text-sm tracking-wide uppercase">
            About Me
          </span>
          <h2 className="text-3xl sm:text-4xl font-light text-gray-900 mt-2">
            Passionate About{' '}
            <span className="font-semibold">Building Great Products</span>
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left - Bio */}
          <div>
            <div className="prose prose-lg text-gray-600 leading-relaxed">
              <p className="mb-6">
                {profileData.bio}
              </p>
              <p className="mb-6">
                Throughout my career, I've had the privilege of working on applications 
                that serve <span className="text-gray-900 font-medium">millions of users</span>. 
                From fintech solutions to ride-sharing platforms, I bring a diverse 
                experience in building scalable, user-centric applications.
              </p>
              <p>
                My approach combines technical excellence with a keen eye for user 
                experience, ensuring that every product I work on is not just functional 
                but delightful to use.
              </p>
            </div>

            {/* Personal Strengths */}
            <div className="mt-8 pt-8 border-t border-gray-100">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Core Strengths</h3>
              <div className="flex flex-wrap gap-3">
                {['Leadership', 'Team Collaboration', 'Problem Solving', 'Communication', 'Initiative'].map((strength) => (
                  <span
                    key={strength}
                    className="px-4 py-2 bg-gray-50 text-gray-700 rounded-full text-sm font-medium"
                  >
                    {strength}
                  </span>
                ))}
              </div>
            </div>
          </div>

          {/* Right - Highlights */}
          <div className="grid sm:grid-cols-2 gap-6">
            {highlights.map((item, index) => (
              <div
                key={index}
                className="group p-6 rounded-2xl bg-gray-50 hover:bg-emerald-50 transition-all duration-300 hover:shadow-lg"
              >
                <div className="w-12 h-12 rounded-xl bg-white shadow-sm flex items-center justify-center mb-4 group-hover:bg-emerald-100 transition-colors">
                  <item.icon className="w-6 h-6 text-emerald-600" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
